/*
 * File: index.tsx
 * Project: meki
 * File Created: Monday, 15th November 2021 5:53:07 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Monday, 15th November 2021 6:01:34 pm
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import { BasePage } from '@components/BaseHome';
import { SEOHead } from '@components/seo';

export default function CheckoutPaymentMethod() {
  return (
    <>
      <SEOHead title="Meki · Metodo de pago" />
      <BasePage />
    </>
  );
}
